import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from "@/views/Dashboard"
import Welcome from "@/views/Welcome"
import Users from "@/views/Users"
import Chart from "@/views/Chart"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Welcome",
    component: Welcome
  },
  {
    path: "/map",
    name: "Map",
  },
  {
    path: "/users",
    name: "Users",
    component: Users
  },
  {
    path: "/chart",
    name: "Chart",
    component: Chart
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: '*',
    redirect: "/"
  }
];

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('user');
  if (to.name == 'Welcome' && isAuthenticated) next({ name: 'Dashboard' })
  else if (!(to.name == 'Welcome') && !isAuthenticated) next({ name: 'Welcome' })
  else next()
})

export default router
